import {Dimensions, Platform, StyleSheet} from 'react-native';

const windowDim = Dimensions.get('window').width;

export const styles = StyleSheet.create({
  wholeContainer: {
    flex: 1,
    backgroundColor: Platform.OS === 'web' ? 'transparent' : 'white',
  },
  container: {flexDirection: 'column', backgroundColor: 'white'},
  resultContainer: {
    backgroundColor: '#f2f6f9',
    width: '100%',
    padding: 40,
    marginVertical: 40,
    borderRadius: 20,
    flexDirection: 'row',
    alignItems: 'center',
  },
  resultDestination: {
    color: '#1d5c42',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  resultMontant: {
    fontSize: 40,
    color: '#1d5c42',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  message: {
    color: '#1d5c42',
    textAlign: 'center',
    fontStyle: 'italic',
  },
  buttonContainer: {
    width: '100%',
    padding: 20,
    position: 'absolute',
    bottom: 0,
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttonContainerWeb: {
    marginLeft: 5,
    width: '100%',
    padding: 20,
    position: 'absolute',
    bottom: 0,
    flexDirection: 'row',
    maxWidth: 600,
    alignItems: 'center',
  },

  buttonContent: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  buttonText: {
    color: '#fff',
    fontWeight: '700',
    textAlign: 'center',
    marginHorizontal: 8,
    paddingHorizontal: 10,
    margin: 0,
    fontSize: 14,
  },
  buttonOuter: {
    backgroundColor: '#0f579e',
    borderRadius: 30,
    height: 50,
    shadowColor: 'rgba(15, 87, 158, 0.9)',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.4,
    shadowRadius: 7,
    elevation: 5,
    marginVertical: 8,
    flexGrow: 0,
    paddingHorizontal: 1,
    marginHorizontal: 5,
    minWidth: 1,
  },
  containerFluid: {
    marginRight: 10,
    marginLeft: 10,
  },
  containerMenuItem: {
    marginVertical: 8,
    marginHorizontal: 8,
    backgroundColor: 'white',
    borderRadius: 16,
    minHeight: 160,
    flexBasis: windowDim / 2 - 60,
    padding: 8,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.03,
    shadowRadius: 10,
    elevation: 5,
  },
  MenuItemFont: {
    marginTop: 20,
    fontSize: 16,
    borderWidth: 0,
    borderColor: '#f2f5f6',
    textAlign: 'center',
    justifyContent: 'center',
  },
  MenuItemLogo: {
    width: 60,
    height: 60,
  },
  dateTimePickerWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  noFlexGrow: {
    flexShrink: 0,
    flexGrow: 0,
    flexBasis: 'auto',
  },
});
